import React, { useState } from "react";
import { FaDownload, FaShare, FaCommentDots,FaFilePowerpoint } from "react-icons/fa";
import { faFilePen } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { HeadingProps } from "../../types/presentationView";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import GuidedTour from "../onboarding/shared/GuidedTour";
import GuidedTourMobile from "../onboarding/shared/GuidedTourMobile";
import FeedbackModal from "./FeedbackModal";
import axios from "axios";
import { Theme } from "../../lib/theme";

export const DesktopHeading: React.FC<
  HeadingProps & {
    slideProgress?: number;
    generatedSlidesCount?: number;
    blockListLength?: number;
    highlightExport?: boolean;
  }
> = ({
  handleShare,
  handleDownload,
  handleDownloadPptx ,
  pptName,
  isLoading,
  userPlan,
  openPricingModal,
  exportPaid,
  buttonsDisabled,
  slideProgress = 0,
  generatedSlidesCount = 0,
  blockListLength = 0,
  highlightExport = true,
  handleSubmitFeedback,
  organisationId,
  documentId,
  token,
  setExportType,
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  return (
    <div className="hidden lg:flex lg:w-full lg:absolute lg:left-0 lg:pl-8 lg:pr-8 lg:pt-4">
      <div className="relative w-full flex items-center">
        {/* === Left: Title aligned to sidebar === */}
        <div
          className="max-w-[250px] truncate text-xl font-semibold"
          title={pptName}
        >
          {isLoading ? (
            <div
              className="w-6 h-6 border-4 border-gray-300 rounded-full animate-spin"
              style={{
                borderTopColor: Theme.colors.primary,
              }}
            ></div>
          ) : (
            pptName
          )}
        </div>

        {/* === Buttons STARTING at main slide viewer === */}
        <div className="absolute left-[30%] lg:left-[26%] xl:left-[25%] 2xl:left-[25%]  flex gap-2 ">
  

        <button
  onClick={async () => {
    setExportType("pdf");
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (response.status !== 200) {
      console.error("Non-200 response:", response.status);
      return;
    }

    const bundle = response.data.bundle;
    console.log(bundle, userPlan, exportPaid);

    if (userPlan === "free" && !exportPaid && bundle <= 0) {
      openPricingModal();
    } else {
      console.log("Ready to download");
      handleDownload(exportPaid ? false : true);
    }
  }}
  disabled={buttonsDisabled}
  className={`flex flex-col items-center px-3 py-1 rounded-md active:scale-95 transition transform duration-500 ${
    highlightExport ? "animate-pulse ring-2 font-bold" : ""
  }`}
  style={{
    backgroundColor: Theme.colors.background,
    border: `1px solid ${Theme.colors.primary}`,
    color: buttonsDisabled
      ? Theme.colors.text.weak
      : Theme.colors.text.weak,
    cursor: buttonsDisabled ? "not-allowed" : "pointer",
    ...(highlightExport && {
      boxShadow: `0 0 0 2px ${Theme.colors.button.hover}`,
    }),
  }}
  onMouseEnter={(e) => {
    if (!buttonsDisabled) {
      e.currentTarget.style.color = Theme.colors.primary;
    }
  }}
  onMouseLeave={(e) => {
    if (!buttonsDisabled) {
      e.currentTarget.style.color = Theme.colors.text.weak;
    }
  }}
>
  {/* First line: icon + Edit on (same line) */}
  <div className="flex items-center gap-1">
    <FontAwesomeIcon icon={faFilePen} className="h-4 w-4" />
    <span>Edit on</span>
  </div>

  {/* Second line: Google Slides centered */}
  <span className="leading-tight text-center">Google Slides</span>
</button>




<button
  onClick={async () => {
    setExportType("pptx");
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
      {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      }
    );

    if (response.status !== 200) {
      console.error("Non-200 response:", response.status);
      return;
    }

    const bundle = response.data.bundle;
    console.log(bundle, userPlan, exportPaid);

    if (userPlan === "free" && !exportPaid && bundle <= 0) {
      openPricingModal();
    } else {
      console.log("Ready to download");
      handleDownloadPptx(exportPaid ? false : true);
    }
  }}
  disabled={buttonsDisabled}
  className={`flex flex-col items-center px-3 py-1 rounded-md active:scale-95 transition transform duration-500 ${
    highlightExport ? "animate-pulse ring-2 font-bold" : ""
  }`}
  style={{
    backgroundColor: Theme.colors.background,
    border: `1px solid ${Theme.colors.primary}`,
    color: buttonsDisabled ? Theme.colors.text.weak : Theme.colors.text.weak,
    cursor: buttonsDisabled ? "not-allowed" : "pointer",
    ...(highlightExport && {
      boxShadow: `0 0 0 2px ${Theme.colors.button.hover}`,
    }),
  }}
  onMouseEnter={(e) => {
    if (!buttonsDisabled) {
      e.currentTarget.style.color = Theme.colors.primary;
    }
  }}
  onMouseLeave={(e) => {
    if (!buttonsDisabled) {
      e.currentTarget.style.color = Theme.colors.text.weak;
    }
  }}
>
  {/* First line: icon + "Download" side by side */}
  <div className="flex items-center gap-1">
    <FaFilePowerpoint className="h-4 w-4" />
    <span>Download</span>
  </div>

  {/* Second line: "Powerpoint" */}
  <span className="leading-tight text-center">Powerpoint</span>
</button>
        </div>

        {/* === Centered Progress Bar === */}
        {slideProgress !== undefined && slideProgress < 100 && (
          <div
            className="absolute top-0 transform -translate-x-1/2"
            style={{ left: "calc(250px + 50% - 250px / 2)" }} // sidebar (250px) + half slide area
          >
            <div className="absolute top-0 left-1/2 transform -translate-x-1/2  w-[35vw] max-w-[400px] ml-6">
              <div
                className="w-full h-8 rounded-md shadow-inner"
                style={{ backgroundColor: Theme.colors.stroke.weak }}
              >
                <div
                  className="h-8 flex items-center justify-center text-white text-[11px] sm:text-xs font-medium rounded-md transition-all duration-300"
                  style={{
                    width: `${slideProgress}%`,
                    backgroundColor: Theme.colors.primary,
                  }}
                >
                  <span className="truncate whitespace-nowrap overflow-hidden text-ellipsis px-2 text-sm font-medium">
                    {`${generatedSlidesCount ?? 0} / ${
                      blockListLength ?? 0
                    } slides ready (${slideProgress}%)`}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        
 {/* === Right-Aligned Share and Feedback Buttons === */}
<div className="absolute md:right-2 lg:right-4 xl:right-8 flex gap-2 items-center">
  {/* Share Button - Just left of Feedback */}
  <button
    onClick={handleShare}
    disabled={buttonsDisabled}
    className="gap-2 flex items-center px-3 py-1 rounded-md active:scale-95 transition transform duration-300 disabled:cursor-not-allowed"
    style={{
      color: buttonsDisabled
        ? Theme.colors.text.weak
        : Theme.colors.text.weak,
      border: `1px solid ${Theme.colors.stroke.weak}`,
      backgroundColor: Theme.colors.background,
      ...(buttonsDisabled ? {} : { cursor: "pointer" }),
    }}
    onMouseEnter={(e) => {
      if (!buttonsDisabled) {
        e.currentTarget.style.color = Theme.colors.primary;
      }
    }}
    onMouseLeave={(e) => {
      if (!buttonsDisabled) {
        e.currentTarget.style.color = Theme.colors.text.weak;
      }
    }}
  >
    <FaShare className="h-3 w-3" />
    <span>Share</span>
  </button>

  {/* Feedback Button - Always at rightmost */}
  <button
    onClick={() => setShowFeedbackModal(true)}
    className="gap-2 px-3 py-1 rounded-md flex items-center active:scale-95 transition transform duration-300 hover:underline"
    style={{
      color: Theme.colors.text.weak,
      backgroundColor: Theme.colors.background,
      border: `1px solid ${Theme.colors.stroke.weak}`,
    }}
    onMouseEnter={(e) =>
      (e.currentTarget.style.color = Theme.colors.primary)
    }
    onMouseLeave={(e) =>
      (e.currentTarget.style.color = Theme.colors.text.weak)
    }
  >
    <FaCommentDots className="h-3 w-3" />
    <span>Give Feedback</span>
  </button>
</div>


        <FeedbackModal
          isOpen={showFeedbackModal}
          onClose={() => setShowFeedbackModal(false)}
          organisationId={organisationId}
          documentId={documentId}
          token={token}
        />

        {/* Optional hidden guided tour */}
        <div className="hidden">
          <GuidedTour />
        </div>
      </div>
    </div>
  );
};

export const MobileHeading: React.FC<
  HeadingProps & { highlightExport?: boolean }
> = ({
  handleDownload,
  handleDownloadPptx,
  handleShare,
  pptName,
  isLoading,
  userPlan,
  openPricingModal,
  exportPaid,
  buttonsDisabled,
  slideProgress,
  generatedSlidesCount,
  blockListLength,
  highlightExport = false,
  handleSubmitFeedback,
  organisationId,
  documentId,
  setExportType,
  token,
}) => {
  const [showFeedbackModal, setShowFeedbackModal] = useState(false);
  const authToken = sessionStorage.getItem("authToken");
  const orgId = sessionStorage.getItem("orgId");
  return (
    <div className="flex items-center justify-between gap-2 relative">
      <div className="flex-1 overflow-hidden">
        <h1 className="text-base font-semibold truncate">
          {isLoading ? (
            <div className="w-full h-full flex items-center justify-center">
              <div className="w-6 h-6 border-4 border-t-blue-500 border-gray-300 rounded-full animate-spin"></div>
            </div>
          ) : (
            pptName
          )}
        </h1>
      </div>

      {typeof slideProgress === "number" && (
        <div className="w-10 h-10 mr-2">
          <CircularProgressbar
            value={slideProgress}
            text={`${generatedSlidesCount ?? 0}/${blockListLength ?? 0}`}
            strokeWidth={8}
            styles={buildStyles({
              textSize: "28px",
              pathColor: Theme.colors.primary,
              textColor: Theme.colors.text.strong,
              trailColor: Theme.colors.stroke.weak,
            })}
          />
        </div>
      )}

<div className="flex gap-2">
  {/* Export PDF Button */}
  <button
    id="export-mobile"
    disabled={buttonsDisabled}
    onClick={async () => {
      setExportType("pdf");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status !== 200) return;
      const bundle = response.data.bundle;
      if (userPlan === "free" && !exportPaid && bundle <= 0)
        openPricingModal();
      else handleDownload(exportPaid ? false : true);
    }}
  className={`border p-2 rounded-md active:scale-95 transition transform duration-300 disabled:cursor-not-allowed ${
    highlightExport ? 'animate-pulse' : ''
  }`}
  style={{
    borderColor: Theme.colors.stroke.weak,
    color: Theme.colors.text.weak,
    boxShadow: highlightExport ? `0 0 0 2px ${Theme.colors.button.primary}` : 'none',
  }}
    onMouseEnter={(e) =>
      (e.currentTarget.style.color = Theme.colors.primary)
    }
    onMouseLeave={(e) =>
      (e.currentTarget.style.color = Theme.colors.text.weak)
    }
  >
<FontAwesomeIcon icon={faFilePen}  className="h-4 w-4" />
  </button>

  {/* Export PowerPoint Button */}
  <button
    id="export-pptx-mobile"
    disabled={buttonsDisabled}
    onClick={async () => {
      setExportType("pptx");
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/data/organizationprofile/organization/${orgId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      if (response.status !== 200) return;
      const bundle = response.data.bundle;
      if (userPlan === "free" && !exportPaid && bundle <= 0)
        openPricingModal();
      else handleDownloadPptx(exportPaid ? false : true);
    }}
    className={`border p-2 rounded-md active:scale-95 transition transform duration-300 disabled:cursor-not-allowed ${
         highlightExport ? 'animate-pulse' : ''
    }`}
    style={{
      borderColor: Theme.colors.stroke.weak,
      color: Theme.colors.text.weak,
      boxShadow: highlightExport ? `0 0 0 2px ${Theme.colors.button.primary}` : 'none',

    }}
    onMouseEnter={(e) =>
      (e.currentTarget.style.color = Theme.colors.primary)
    }
    onMouseLeave={(e) =>
      (e.currentTarget.style.color = Theme.colors.text.weak)
    }
  >
    <FaFilePowerpoint className="h-4 w-4" title="Export as PPTX" />
  </button>

  {/* Share Button */}
  <button
    id="share-mobile"
    onClick={handleShare}
    disabled={buttonsDisabled}
    className="p-2 rounded-md active:scale-95 transition transform duration-300 disabled:cursor-not-allowed"
    style={{
      backgroundColor: Theme.colors.background,
      color: Theme.colors.text.weak,
      border: `1px solid ${Theme.colors.stroke.weak}`,
    }}
  >
    <FaShare className="h-4 w-4" />
  </button>

  {/* Feedback Button */}
  <button
    id="feedback-mobile"
    onClick={() => setShowFeedbackModal(true)}
    className="gap-2 p-2 py-1 rounded-md flex items-center active:scale-95 transition transform duration-300"
    style={{
      backgroundColor: Theme.colors.background,
      color: Theme.colors.text.weak,
      border: `1px solid ${Theme.colors.stroke.weak}`,
    }}
    onMouseEnter={(e) =>
      (e.currentTarget.style.color = Theme.colors.primary)
    }
    onMouseLeave={(e) =>
      (e.currentTarget.style.color = Theme.colors.text.weak)
    }
  >
    <FaCommentDots className="h-4 w-4" />
  </button>

  <FeedbackModal
    isOpen={showFeedbackModal}
    onClose={() => setShowFeedbackModal(false)}
    organisationId={organisationId}
    documentId={documentId}
    token={token}
  />
</div>


      <GuidedTourMobile />
    </div>
  );
};
